export default "__VITE_ASSET__Cv8ZV7js__"